import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  // BehaviorSubject to store UserName
  private currentUserSubject: BehaviorSubject<any>;

  // Make UserName store Observable
  public currentUser: Observable<any>;

  constructor() {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('user')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  setCurrentUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('isLoggedIn', '1');
    this.currentUserSubject.next(user);
  }

  cleanCurrentUser() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('user');
    this.currentUserSubject.next(null);
  }
}
